import Icon from 'veui/components/Icon'

Icon.register({
  'arrow-down': {
    paths: [
      {
        d: 'M23.85 2.22H24a2 2 0 012 1.85v35.4l13.89-13.88a2 2 0 012.7-.12l.12.12a2 2 0 01.12 2.7l-.12.12-17.25 17.25a2 2 0 01-2.7.12l-.12-.12L5.39 28.41a2 2 0 012.7-2.94l.12.12L22 39.37V4.21a2 2 0 011.85-1.99H24h-.15z'
      }
    ],
    width: '48',
    height: '48'
  }
})
